export interface Event {
  id: string;
  title: string;
  time: string;
  starts_at: string; // ISO datetime string
  available_spots: number;
  occupied_spots: number;
  capacity: number; // Total capacity
  level_needed: string; // Deprecated: use level_requirement instead
  level_requirement?: string; // Level ID: "level_1" to "level_5"
  location: string;
  address?: string; // Full address
  formatted_address?: string; // Radar-standardized address
  latitude?: number;
  longitude?: number;
  sport_type: string;
  activity_type?: string; // Activity type (e.g., 'Tennis', 'Badminton')
  host_name?: string;
  host_profile_picture?: string | null;
  description?: string;
  created_by?: string; // User ID of the event creator
  auto_accept?: boolean; // If true, free to join without request approval
  status?: 'ACTIVE' | 'CANCELED';
  cancellation_deadline_hours?: number;
  images?: {
    image_1?: string | null;
    image_2?: string | null;
    image_3?: string | null;
  };
  tags?: Array<{
    id: string;
    name: string;
    color?: string;
    description?: string;
  }>;
  like_count?: number;
  is_liked_by_user?: boolean;
}

export type EventLevel = 'Beginner' | 'Intermediate' | 'Advanced' | 'Any Level';

export type LevelId = 'level_1' | 'level_2' | 'level_3' | 'level_4' | 'level_5';

export interface Level {
  id: LevelId; // Generic ID: "level_1" to "level_5"
  genericName: string; // Generic name: "新手", "初级", "中级", "高级", "专家"
  range: string; // Sport-specific range: "1.0–1.5", "HC >36", etc.
  description: string; // Sport-specific description
  type?: string; // Additional info: 玩法, 场地, etc.
  capacityLimit?: string; // 限定人数
  description2?: string; // 描述 2
}

export type SportType =
  | 'Tennis'
  | 'Badminton'
  | 'Golf'
  | 'Bouldering'
  | 'Pickleball'
  | 'Gym'
  | 'Hiking'
  | 'Ski/Snowboarding';

export const SUPPORTED_SPORTS: SportType[] = [
  'Tennis',
  'Badminton',
  'Golf',
  'Bouldering',
  'Pickleball',
  'Gym',
  'Hiking',
  'Ski/Snowboarding'
];
